import { cn } from '@/lib/utils'
import { ButtonHTMLAttributes, FC } from 'react'

export const BlueYellowButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({
	children,
	...rest
}) => {
	return (
		<button
			{...rest}
			className={cn('w-full h-[52px] bg-[#5664FF] rounded-[22px]', rest.className)}>
			{children}
		</button>
	)
}
